import { apiServices } from "../../../../core/utilities/ApiServices";

export type SecondLookDecisionType = "rejected" | "liked";
export type SecondLookDecisionSource =
	| "discovery"
	| "second_look"
	| "continue_farther";

export const saveSecondLookDecision = async (
	userId: string,
	type: SecondLookDecisionType,
	source: SecondLookDecisionSource = "second_look",
): Promise<void> => {
	const response = await apiServices.post("/match/second-look/decision", {
		user_id: userId,
		type,
		source,
	});
	if (response.status < 200 || response.status >= 300) {
		throw new Error("Second Look decision was not saved");
	}
};
